const crm = {
  path: '/crm',
  component: () => import('@/views/pages/Crm/RouterHome.vue'),
  meta: { layout: 'content' },
  children: [
    {
      path: 'boards',
      component: () => import('@/views/pages/Crm/Boards/CanceledPreBoard.vue'),
      meta: { layout: 'content' },
      children: [
        {
          path: 'dashboard',
          name: 'crm-board-canceled-pre-dashboard',
          component: () => import('@/views/pages/Crm/Boards/Dashboard.vue'),
          meta: {
            layout: 'content',
          },
        },
        {
          path: 'distribution',
          name: 'crm-board-distribution',
          component: () => import('@/views/pages/Crm/Boards/DistributionBoard.vue'),
          meta: {
            layout: 'content',
          },
        },
        {
          path: 'approval-center',
          name: 'crm-board-approval-center',
          component: () => import('@/views/pages/Crm/Boards/ApprovalCenter.vue'),
          meta: {
            layout: 'content',
          },
        },
        {
          path: 'wallet-updates',
          name: 'crm-board-wallet-updates',
          component: () => import('@/views/pages/Crm/Boards/WalletUpdates.vue'),
          meta: {
            layout: 'content',
          },
        },
      ],
    },
    {
      path: 'titulos',
      component: () => import('@/views/pages/Crm/Boards/TitlesKanban.vue'),
      meta: { layout: 'content' },
      redirect: { name: 'crm-kamban' },
      children: [
        {
          path: 'kamban',
          name: 'crm-kamban',
          component: () => import('@/views/pages/Crm/Crm.vue'),
          meta: {
            layout: 'content',
          },
        },
        {
          path: 'bonifications',
          name: 'bonifications-title',
          component: () => import('@/views/pages/Crm/BonificationsTitles.vue'),
          meta: {
            layout: 'content',
          },
        },
        {
          path: 'search/client',
          name: 'search-client-title',
          component: () => import('@/views/pages/Crm/SearchClient.vue'),
          meta: {
            layout: 'content',
          },
        },
      ],
    },
  ],
}

export default crm
